import { Textarea } from '@chakra-ui/react';
import React from 'react';
import './InputTextArea.css';

function InputTextArea({ ...rest }) {
  return <Textarea className="inputTextArea" {...rest} size="sm" />;
}

export default InputTextArea;
